// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Register.css */

.register-container {
    max-width: 600px;
    margin: 5% auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.register-heading {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold;
}

.form-group input {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
}

.form-group input:focus {
    outline: none;
    border-color: #4E3B31;
}

.form-group-row {
    display: flex;
    justify-content: space-between;
}

.form-group.half {
    width: 48%;
}

.error-message {
    color: red;
    font-size: 0.9rem;
    margin-top: 5px;
}

.submit-button {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    background-color: #4E3B31;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.submit-button:hover {
    background-color: #4E3B31;
}

.loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    margin: 5% auto;
    /* Adjust as needed */
}`, "",{"version":3,"sources":["webpack://./src/style/Register.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,uCAAuC;AAC3C;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,qBAAqB;AACzB","sourcesContent":["/* Register.css */\r\n\r\n.register-container {\r\n    max-width: 600px;\r\n    margin: 5% auto;\r\n    padding: 20px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.register-heading {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n}\r\n\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 1rem;\r\n    border: 1px solid #ccc;\r\n    border-radius: 5px;\r\n}\r\n\r\n.form-group input:focus {\r\n    outline: none;\r\n    border-color: #4E3B31;\r\n}\r\n\r\n.form-group-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.form-group.half {\r\n    width: 48%;\r\n}\r\n\r\n.error-message {\r\n    color: red;\r\n    font-size: 0.9rem;\r\n    margin-top: 5px;\r\n}\r\n\r\n.submit-button {\r\n    width: 100%;\r\n    padding: 10px;\r\n    font-size: 1rem;\r\n    background-color: #4E3B31;\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.submit-button:hover {\r\n    background-color: #4E3B31;\r\n}\r\n\r\n.loading-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 200px;\r\n    margin: 5% auto;\r\n    /* Adjust as needed */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
